import { useState, useEffect, useCallback } from 'react';
import { fetchOdooBillingLog } from '../utils/api';

/**
 * Fetches the recent Odoo billing webhook calls and the billing config.
 */
export function useOdooBilling() {
  const [entries, setEntries] = useState([]);
  const [config, setConfig] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const json = await fetchOdooBillingLog();
      setEntries(json.data || []);
      setConfig(json.config || null);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  return { entries, config, loading, error, refetch: load };
}
